import { BaseError } from '@kiplin/web-common/error';

export class NoClientLandingPageReachedError extends BaseError {
  public static readonly code = '57f32e40-2c5d-4c09-aaf7-4ca8e2a10b41';

  public constructor() {
    super(
      NoClientLandingPageReachedError.code,
      'The user reached the landing page because their profile has no client',
    );
  }
}
